/**
 * Desktop: screen2 spec cards slide up left-to-right on scroll (ScrollTrigger stagger).
 * Mobile and reduced-motion keep static layout.
 */
(function () {
  "use strict";

  const ROOT_SELECTOR = "[data-dop-frs]";
  const SCREEN2_SELECTOR = "[data-dop-frs-screen2]";
  const CARD_SELECTOR = "[data-dop-frs-card]";
  const DESKTOP_QUERY = "(min-width: 721px)";

  const mmMap = new WeakMap();

  function markReady(root) {
    root.setAttribute("data-dop-frs-cards-ready", "");
  }

  function destroyRoot(root) {
    const mm = mmMap.get(root);
    if (mm) {
      mm.revert();
      mmMap.delete(root);
    }

    root.removeAttribute("data-dop-frs-cards-ready");
  }

  function initRoot(root) {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      return;
    }

    const screen2 = root.querySelector(SCREEN2_SELECTOR);
    const cards = Array.from(root.querySelectorAll(CARD_SELECTOR));

    if (!screen2 || !cards.length) {
      return;
    }

    destroyRoot(root);
    gsap.registerPlugin(ScrollTrigger);

    const mm = gsap.matchMedia();

    mm.add(
      {
        isDesktop: DESKTOP_QUERY,
        reduceMotion: "(prefers-reduced-motion: reduce)",
      },
      (context) => {
        const { isDesktop, reduceMotion } = context.conditions;

        if (!isDesktop) {
          return;
        }

        if (reduceMotion) {
          gsap.set(cards, { y: 0, opacity: 1, clearProps: "transform" });
          markReady(root);
          return;
        }

        gsap.set(cards, { y: 96, opacity: 0 });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: screen2,
            start: "top 30%",
            toggleActions: "play none none none",
            once: true,
          },
          onComplete: () => {
            markReady(root);
          },
        });

        tl.to(cards, {
          y: 0,
          opacity: 1,
          duration: 0.65,
          ease: "power2.out",
          stagger: 0.32,
        });

        return () => {
          gsap.killTweensOf(cards);
        };
      },
      root
    );

    mmMap.set(root, mm);
    ScrollTrigger.refresh();
  }

  function initAll(scope = document) {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => initRoot(root));
  }

  function refreshTriggers() {
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  }

  function onPageHide() {
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => destroyRoot(root));
    window.removeEventListener("load", refreshTriggers);
    window.removeEventListener("pagehide", onPageHide);
  }

  function bootstrap() {
    initAll();
    window.addEventListener("load", refreshTriggers, { once: true });
    window.addEventListener("pagehide", onPageHide);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootstrap, { once: true });
  } else {
    bootstrap();
  }

  document.addEventListener("shopify:section:load", (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (!root) {
      return;
    }

    initRoot(root);
    refreshTriggers();
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const root = event.target.querySelector(ROOT_SELECTOR);
    if (root) {
      destroyRoot(root);
    }
  });
})();
